export enum RoutePath {
  BANK_VIEW = '/bank-view',
  BANK_SERVICE_VIEW = '/bank-view/service',
  REPORTING_VIEW = '/reporting',
  BANKER_SERVICE_VIEW = '/book-view/service',
  BANKER_SERVICE_VIEW_WITH_ID = '/book-view/:id/service',
  BANKER_VIEW = '/book-view',
  BANKER_VIEW_WITH_ID = '/book-view/:id',
  CLIENT_VIEW = '/client-view/:id',
  ERROR = '/error',
  LOGGED_OUT = '/logged-out',
  MARKET_VIEW = '/market-view',
  MARKET_VIEW_WITH_ID = '/market-view/:id',
  MARKET_SERVICE_VIEW = '/market-view/service',
  MARKET_SERVICE_VIEW_WITH_ID = '/market-view/:id/service',
  NOT_FOUND = '/:pathMatch(.*)*',
  PROSPECT_VIEW = '/prospect-view',
  PROSPECT_VIEW_WITH_ID = '/prospect-view/:id',
  REDIRECT = '/redirect',
  ROOT = '/',
  TASK_LIST = '/task-list',
  TASK = '/task-list/:id',
  TASK_LIST_ALL = '/task-list-all',
  TEAM_VIEW = '/team-view',
  TEAM_VIEW_WITH_ID = '/team-view/:id',
  TEAM_SERVICE_VIEW = '/team-view/service',
  TEAM_SERVICE_VIEW_WITH_ID = '/team-view/:id/service',
  SALESFORCE_CALLBACK = '/salesforce',
  BONUS_CALCULATOR = '/bonus-calculator',
  EMBED = '/embed',
  EMBED_OPPORTUNITIES = 'opportunities',
  LEAD_OVERVIEW = '/lead-overview',
  INDIVIDUAL_LEAD = '/lead-overview/:id',
  QUICK_REJECT_VIEW = '/quick-reject/:id',
  SALES_PIPELINE = '/sales-pipeline',
  X_PLAN_LEAD = '/x_plan_lead/:id',
}

export enum RouteName {
  BANK_VIEW = 'BANK_VIEW',
  BANK_SERVICE_VIEW = 'BANK_SERVICE_VIEW',
  REPORTING_VIEW = 'REPORTING_VIEW',
  BANKER_SERVICE_VIEW = 'BANKER_SERVICE_VIEW',
  BANKER_SERVICE_VIEW_WITH_ID = 'BANKER_SERVICE_VIEW_WITH_ID',
  BANKER_VIEW = 'BANKER_VIEW',
  BANKER_VIEW_WITH_ID = 'BANKER_VIEW_WITH_ID',
  CLIENT_VIEW = 'CLIENT_VIEW',
  ERROR = 'ERROR',
  LOGGED_OUT = 'LOGGED_OUT',
  MARKET_VIEW = 'MARKET_VIEW',
  MARKET_VIEW_WITH_ID = 'MARKET_VIEW_WITH_ID',
  MARKET_SERVICE_VIEW = 'MARKET_SERVICE_VIEW',
  MARKET_SERVICE_VIEW_WITH_ID = 'MARKET_SERVICE_VIEW_WITH_ID',
  NOT_FOUND = 'NOT_FOUND',
  PROSPECT_VIEW = 'PROSPECT_VIEW',
  PROSPECT_VIEW_WITH_ID = 'PROSPECT_VIEW_WITH_ID',
  REDIRECT = 'REDIRECT',
  ROOT = 'ROOT',
  TASK_LIST = 'TASK_LIST',
  TASK = 'TASK',
  TASK_LIST_ALL = 'TASK_LIST_ALL',
  TEAM_VIEW = 'TEAM_VIEW',
  TEAM_VIEW_WITH_ID = 'TEAM_VIEW_WITH_ID',
  TEAM_SERVICE_VIEW = 'TEAM_SERVICE_VIEW',
  TEAM_SERVICE_VIEW_WITH_ID = 'TEAM_SERVICE_VIEW_WITH_ID',
  SALESFORCE_CALLBACK = 'SALESFORCE_CALLBACK',
  BONUS_CALCULATOR = 'BONUS_CALCULATOR',
  EMBED = 'EMBED',
  EMBED_OPPORTUNITIES = 'EMBED_OPPORTUNITIES',
  LEAD_OVERVIEW = 'LEAD_OVERVIEW',
  INDIVIDUAL_LEAD = 'INDIVIDUAL_LEAD',
  QUICK_REJECT_VIEW = 'QUICK_REJECT_VIEW',
  SALES_PIPELINE = 'SALES_PIPELINE',
  X_PLAN_LEAD = 'X_PLAN_LEAD',
}
